import { useState } from 'react'
import bg from "../../../../../assets/images/core/attract/bg.png";
import Ft_img from '../../../../../assets/images/core/attract/ft.png'
import Logo from '../../../../../assets/images/core/dadas_logo.png'

export const PromoProduct = () => {
    const [templates, setTemplates] = useState({preview: {toggled: false}})
    const [prodTemplate, setProdTemplate] = useState({
        type: 'product',
        method: 'create',
        pstatus: null,
        pid: null,
        submit: {modal: false, type: '', confirmed: false}, 
        inputs: {
            title: { value: 'New Year Promo!', stat: false, msg: '', },
            promo_caption: {value: 'EXPERIENCE BRAND NEW POFSIS LAPTOP ',  stat: false, msg: ''},
            promo_details: [
                {value: '2.5KG', stat: false, msg: ''},
                {value: 'Good for 20-25px', stat: false, msg: ''},
                {value: 'with 1 bottle of dadas suka', stat: false, msg: ''},
            ],
            reg_price: { value: '1400', stat: false, msg: '' },
            discount_percent: { value: '10', stat: false, msg: '' },
            category: { value: '', stat: true, msg: 'This field is required.' },
            sub_category: { value: '', stat: true, msg: 'This field is required.' },
            weight: { value: '', stat: true, msg: 'This field is required.' },
            length: { value: '', stat: true, msg: 'This field is required.' },
            width: { value: '', stat: true, msg: 'This field is required.' },
            height: { value: '', stat: true, msg: 'This field is required.' },
            pickup_option: { value: '', stat: true, msg: 'This field is required.' },
            delivery: { value: false, stat: true, msg: 'Required to choose at least one' },
            delivery_option: { value: '', stat: false, msg: '' },
            // processing_time: { value: '', stat: false, msg: '' },
            pickup: { value: false, stat: true, msg: 'This field is required.' },
            pickup_address: {value: '',  stat: true, msg: 'This field is required.'}, 
            pickup_place_id: {value: '',  stat: false, msg: ''},
            pickup_branch_name: {value: '',  stat: false, msg: ''},
            street_name: {value: '',  stat: false, msg: ''}, 
            area_name: {value: '',  stat: false, msg: ''}, 
            pickup_province: {value: '',  stat: false, msg: ''},  
            pickup_city: {value: '',  stat: false, msg: ''},  
            pickup_barangay: {value: '',  stat: false, msg: ''},  
            pickup_num: {value: '',  stat: false, msg: ''},  
            nearest: {value: '',  stat: false, msg: ''},  
            pickup_datetime: {value: '',  stat: false, msg: ''}, 
            pickup_branch_code: { value: '', stat: false, msg: '' },
            rate: {value: '1360', stat: false, msg: '', toggled: false},
            bg: {value: '', object: bg, name: 'bg', type: 'default', stat: false, msg: ''},
            logo: {value: '', object: Logo, name: 'logo', type: 'default', stat: false, msg: ''},
            ft_img: {value: '', object: Ft_img, name: 'ft_img', type: 'default', stat: false, msg: ''},
            price_bg: {value: '#ff3d00',  stat: false, msg: ''},
            button_caption: {value: 'Order Now',  stat: false, msg: ''},
            contact_num: {value: '09174592075',  stat: false, msg: ''},
            facebook: {value: '',  stat: true, msg: 'This field is required.'},
            instagram: {value: '',  stat: true, msg: 'This field is required.'},
            website: {value: 'www.dadaslitson.com',  stat: false, msg: ''},
            promo_name: {value: '',  stat: true, msg: 'This field is required.'},
            start: {value: '',  stat: true, msg: 'This field is required.'},
            end: {value: '',  stat: true, msg: 'This field is required.'},
            promo_limit: {value: '',  stat: false, msg: ''},
            text_promo: {value: '',  stat: false, msg: '', show: false},
            partial: {value: '', stat: true, msg: '', toggled: false},
            full_address: { value: '', stat: false, msg: '' },
        }
    })
    const dflt = {
        type: 'product',
        method: 'create',
        pstatus: null,
        pid: null,
        submit: {modal: false, type: '', confirmed: false}, 
        inputs: {
            title: { value: 'New Year Promo!', stat: false, msg: '', },
            promo_caption: {value: 'EXPERIENCE BRAND NEW POFSIS LAPTOP ',  stat: false, msg: ''},
            promo_details: [
                {value: '2.5KG', stat: false, msg: ''},
                {value: 'Good for 20-25px', stat: false, msg: ''},
                {value: 'with 1 bottle of dadas suka', stat: false, msg: ''},
            ],
            reg_price: { value: '1400', stat: false, msg: '' },
            discount_percent: { value: '10', stat: false, msg: '' },
            category: { value: '', stat: true, msg: 'This field is required.' },
            sub_category: { value: '', stat: true, msg: 'This field is required.' },
            weight: { value: '', stat: true, msg: 'This field is required.' },
            length: { value: '', stat: true, msg: 'This field is required.' },
            width: { value: '', stat: true, msg: 'This field is required.' },
            height: { value: '', stat: true, msg: 'This field is required.' },
            pickup_option: { value: '', stat: true, msg: 'This field is required.' },
            delivery: { value: false, stat: true, msg: 'Required to choose at least one' },
            delivery_option: { value: '', stat: false, msg: '' },
            // processing_time: { value: '', stat: false, msg: '' },
            pickup: { value: false, stat: true, msg: 'This field is required.' },
            full_address: { value: '', stat: false, msg: '' },
            pickup_address: {value: '',  stat: true, msg: 'This field is required.'}, 
            pickup_place_id: {value: '',  stat: false, msg: ''},
            pickup_branch_name: { value: '', stat: false, msg: '' },
            street_name: { value: '', stat: false, msg: '' },
            area_name: { value: '', stat: false, msg: '' },
            pickup_province: { value: '', stat: false, msg: '' },
            pickup_city: { value: '', stat: false, msg: '' },
            pickup_barangay: { value: '', stat: false, msg: '' },
            pickup_num: {value: '',  stat: true, msg: 'This field is required.'},  
            nearest: {value: '',  stat: true, msg: 'This field is required.'},  
            pickup_datetime: {value: '',  stat: true, msg: 'This field is required.'}, 
            pickup_branch_code: { value: '', stat: true, msg: 'This field is required.' },
            rate: {value: '1360', stat: false, msg: '', toggled: false},
            bg: {value: '', object: bg, name: 'bg', type: 'default', stat: false, msg: ''},
            logo: {value: '', object: Logo, name: 'logo', type: 'default', stat: false, msg: ''},
            ft_img: {value: '', object: Ft_img, name: 'ft_img', type: 'default', stat: false, msg: ''},
            price_bg: {value: '#ff3d00',  stat: false, msg: ''},
            button_caption: {value: 'Order Now',  stat: false, msg: ''},
            contact_num: {value: '09174592075',  stat: false, msg: ''},
            facebook: {value: '',  stat: true, msg: 'This field is required.'},
            instagram: {value: '',  stat: true, msg: 'This field is required.'},
            website: {value: 'www.dadaslitson.com',  stat: false, msg: ''},
            promo_name: {value: '',  stat: true, msg: 'This field is required.'},
            start: {value: '',  stat: true, msg: 'This field is required.'},
            end: {value: '',  stat: true, msg: 'This field is required.'},
            promo_limit: {value: '',  stat: false, msg: ''},
            text_promo: {value: '',  stat: false, msg: '', show: false},
            partial: {value: '', stat: true, msg: '', toggled: false},
        }
    }
    const [prodList, setProdList] = useState([])
    const [confirmation, setConfirmation] = useState({open: false, type: '', loader: false})
    const [categoryList, setCategoryList] = useState([])
    const [subCategory, setSubCategory] = useState([])
    const [listLoader, setListLoader] = useState(true)
    const [action, setAction] = useState({show: null, selected: ''})
    const [viewLoader, setViewLoader] = useState(false)
    const [shippingCount, setShippingCount] = useState([])
    const [pickupAddresses, setPickupAddresses] = useState([]);
    const [selectedPickupAddress, setSelectedPickupAddress] = useState(null);

    return {
        templates: {data: templates, set: setTemplates},
        prodTemplate: { data: prodTemplate, set: setProdTemplate },
        dflt: { data: dflt },
        prodList: { data: prodList, set: setProdList },
        confirmation: { data: confirmation, set: setConfirmation },
        categoryList: { data: categoryList, set: setCategoryList },
        subCategory: { data: subCategory, set: setSubCategory },
        listLoader: { data: listLoader, set: setListLoader},
        action: { data: action, set: setAction},
        viewLoader: { data: viewLoader, set: setViewLoader},
        shippingCount: { data: shippingCount, set: setShippingCount},
        pickupAddresses: { data: pickupAddresses, set: setPickupAddresses},
        selectedPickupAddress: { data: selectedPickupAddress, set: setSelectedPickupAddress},
    }
}
